t = require('views/internal/teacup-with-helpers')('boards_page_activity_feed')

module.exports = t.renderable ({ organizationList, currentFilter }) ->

  t.ul '.js-filter-click.pop-over-list', ->
    t.li { 'data-filterId': '' }, ->
      t.a ->
        t.text 'All Activity'
        if currentFilter == ''
          t.icon 'check', { class: 'selected-filter-item' }

    for org in organizationList
      t.li { 'data-filterId': org.id }, ->
        t.a ->
          t.text org.get('displayName') + ' Activity'
          if currentFilter == org.id
            t.icon 'check', { class: 'selected-filter-item' }

    t.li { 'data-filterId': 'personal' }, ->
      t.a ->
        t.text 'Personal'
        if currentFilter == 'personal'
          t.icon 'check', { class: 'selected-filter-item' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/activity_feed_filter.coffee